(function () {
  function money(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || (window.themeMoneyFormat || '${{amount}}'));
    }
    var amount = (Number(cents) / 100).toFixed(2);
    return '$' + amount;
  }

  function initProduct(section) {
    var productJsonEl = section.querySelector('[data-product-json]');
    if (!productJsonEl) return;

    var product;
    try {
      product = JSON.parse(productJsonEl.textContent);
    } catch (e) {
      return;
    }

    var form = section.querySelector('[data-product-form]');
    var variantInput = section.querySelector('[data-variant-id]');
    var optionSelects = section.querySelectorAll('[data-option-select]');
    var priceEl = section.querySelector('[data-product-price]');
    var addBtn = section.querySelector('[data-add-to-cart]');
    var addText = section.querySelector('[data-add-to-cart-text]');
    var mainImg = section.querySelector('[data-gallery-main] img');
    var thumbs = section.querySelectorAll('[data-gallery-thumbs] [data-media-id]');
    var qtyInput = section.querySelector('[data-qty-input]');
    var qtyDec = section.querySelector('[data-qty-decrease]');
    var qtyInc = section.querySelector('[data-qty-increase]');

    function findVariant() {
      if (!optionSelects.length) {
        return product.variants[0];
      }
      var selected = Array.prototype.map.call(optionSelects, function (sel) {
        return sel.value;
      });
      return product.variants.find(function (v) {
        return selected.every(function (val, i) {
          return v.options[i] === val;
        });
      });
    }

    function setActiveThumb(mediaId) {
      thumbs.forEach(function (btn) {
        var active = String(btn.getAttribute('data-media-id')) === String(mediaId);
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function updateGallery(mediaId) {
      if (!mediaId || !mainImg) return;
      var thumb = section.querySelector('[data-gallery-thumbs] [data-media-id="' + mediaId + '"]');
      if (!thumb) return;
      var src = thumb.getAttribute('data-media-src');
      var srcset = thumb.getAttribute('data-media-srcset');
      var alt = thumb.getAttribute('data-media-alt') || '';
      if (src) mainImg.src = src;
      if (srcset) mainImg.srcset = srcset;
      mainImg.alt = alt;
      mainImg.setAttribute('data-media-id', mediaId);
      setActiveThumb(mediaId);
    }

    function renderPrice(variant) {
      if (!priceEl || !variant) return;
      var html = '<span class="price">' + money(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += ' <s class="price__compare">' + money(variant.compare_at_price) + '</s>';
        html += ' <span class="badge badge--sale badge--inline">Sale</span>';
      }
      html += '</span>';
      priceEl.innerHTML = html;
    }

    function updateVariant() {
      var variant = findVariant();
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      renderPrice(variant);
      if (addBtn) addBtn.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? 'Add to cart' : 'Sold out';

      var mediaId = variant.featured_media && variant.featured_media.id
        ? variant.featured_media.id
        : (variant.featured_image && variant.featured_image.id);
      if (mediaId) updateGallery(mediaId);

      if (variant.id && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    optionSelects.forEach(function (sel) {
      sel.addEventListener('change', updateVariant);
    });

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateGallery(btn.getAttribute('data-media-id'));
      });
    });

    if (qtyDec && qtyInput) {
      qtyDec.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = v;
      });
    }
    if (qtyInc && qtyInput) {
      qtyInc.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1);
        qtyInput.value = v;
      });
    }
  }

  document.querySelectorAll('.product-section').forEach(initProduct);
})();
